import { useCallback, useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';

export const useChartModal = () => {
  const [chartModalState, setChartModalState] = useState({
    isOpen: false,
    content: null,
    title: '',
  });

  const openChartModal = useCallback((chartOptions, title) => {
    setChartModalState({ isOpen: true, content: chartOptions, title });
  }, []);

  const closeChartModal = useCallback(() => {
    setChartModalState({ isOpen: false, content: null, title: '' });
  }, []);

  const handleChartModalBackdropClick = useCallback(
    (event) => {
      if (event.target === event.currentTarget) {
        closeChartModal();
      }
    },
    [closeChartModal]
  );

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape' && chartModalState.isOpen) {
        closeChartModal();
      }
    };

    if (chartModalState.isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [chartModalState.isOpen, closeChartModal]);

  return {
    chartModalState,
    openChartModal,
    closeChartModal,
    handleChartModalBackdropClick,
  };
};

const ChartModal = ({ chartModalState, onClose, onBackdropClick }) => {
  if (!chartModalState.isOpen) {
    return null;
  }

  return (
    <div className="chart-modal-overlay" onClick={onBackdropClick}>
      <div className="chart-modal">
        <div className="chart-modal-header">
          <h3>{chartModalState.title}</h3>
          <button className="chart-modal-close" onClick={onClose} type="button">
            ✕
          </button>
        </div>
        <div className="chart-modal-content">
          <ReactECharts option={chartModalState.content} style={{ height: '600px', width: '100%' }} />
        </div>
      </div>
    </div>
  );
};

export default ChartModal;
